"use strict";

var debounce = require("lodash/debounce");
var endpoint = $(".suggestions-wrapper").data("url");
var minChars = 3;
var DEFAULT_SUGGEST_DELAY = 400;
var suggestDelay = Number($(".suggestions-wrapper").data("delay")) || DEFAULT_SUGGEST_DELAY;
var suggestRequest = null;
var lastQuery = null;
var lastResponse = null;
var ENTER_KEY = 13;
var UP_KEY = 38;
var DOWN_KEY = 40;
var DIRECTION_DOWN = 1;
var DIRECTION_UP = -1;
const gtmHelpers = require("../helpers/gtmHelpers");

/**
 * Retrieves Suggestions element relative to scope
 *
 * @param {Object} scope - Search input field DOM element
 * @return {JQuery} - .suggestions-wrapper element
 */
function getSuggestionsWrapper(scope) {
    return $(scope).parents(".header-container").find(".suggestions-wrapper");
}

/**
 * Determines whether DOM element is inside the .search-mobile class
 *
 * @param {Object} scope - DOM element, usually the input.search-field element
 * @return {boolean} - Whether DOM element is inside  div.search-mobile
 */
function isMobileSearch(scope) {
    return !!$(scope).closest(".search-mobile").length;
}

/**
 * Remove modal classes needed for mobile suggestions
 *
 */
function clearModals() {
    $("body").removeClass("modal-open");
    $("header").siblings().attr("aria-hidden", "false");
    $(".suggestions").removeClass("modal");
}

/**
 * Apply modal classes needed for mobile suggestions
 *
 * @param {Object} scope - Search input field DOM element
 */
function applyModals(scope) {
    if (isMobileSearch(scope)) {
        $("body").addClass("modal-open");
        $("header").siblings().attr("aria-hidden", "true");
        getSuggestionsWrapper(scope).find(".suggestions").addClass("modal");
    }
}

/**
 * Tear down Suggestions panel
 */
function tearDownSuggestions() {
    resetSuggestState();
    $("input.search-field").val("");
    clearModals();
    $(".search-mobile .suggestions").unbind("scroll");
    $(".suggestions-wrapper").empty();
}

/**
 * Toggle search field icon from search to close and vice-versa
 *
 * @param {string} action - Action to toggle to
 */
function toggleSuggestionsIcon(action) {
    var mobileSearchIcon = ".search-mobile button.";
    var iconSearch = "fa-search";
    var iconSearchClose = "fa-close";

    if (action === "close") {
        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr("type", "button");
    } else {
        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr("type", "submit");
    }
}

/**
 * Process Ajax response for SearchServices-GetSuggestions
 *
 * @param {Object|string} response - Empty object literal if null response or string with rendered
 *                                   suggestions template contents
 */
function processResponse(response) {
    var $suggestionsWrapper = getSuggestionsWrapper(this).empty();
    $.spinner().stop();

    if (typeof (response) !== "object" && $.trim($(response).find("#search-results").html()).length >0) {

        $suggestionsWrapper.append(response);
        $(this).siblings(".reset-button").removeClass("d-none");
        $("body").addClass("no-scroll-mobile");
        $(".search-key-wrapper").slideDown();
        $(".search-focus-wrapper").slideUp();
        $(".suggestions-carousel").slick({
            slidesToShow: 1.8,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            mobileFirst: true,
            variableWidth: true,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 4.5
                }
            }]
        });

        if (isMobileSearch(this)) {
            toggleSuggestionsIcon("close");
            applyModals(this);
        }

        // Trigger screen reader by setting aria-describedby with the new suggestion message.
        var suggestionsList = $(".suggestions .item");
        if ($(suggestionsList).length) {
            $("input.search-field").attr("aria-describedby", "search-result-count");
        } else {
            $("input.search-field").removeAttr("aria-describedby");
        }
    } else {
        $suggestionsWrapper.hide();
    }
}

/**
 * Abort the suggest request still in flight, if any. Its query never got an answer, so it is sent again next time.
 */
function abortSuggestRequest() {
    if (suggestRequest) {
        var request = suggestRequest;
        suggestRequest = null;
        lastQuery = null;
        request.abort();
    }
}

/**
 * Abort any suggest request and forget the last query and its suggestions
 */
function resetSuggestState() {
    abortSuggestRequest();
    lastQuery = null;
    lastResponse = null;
}

/**
 * Show the suggestions of the last query again, if they were closed
 *
 * @param {Object} scope - Search field DOM element
 * @param {boolean} [closing] - Whether a dropdown still sliding up counts as closed, as it does on focus just after an
 *                              outside click: jQuery runs the slide down after it
 */
function showLastSuggestions(scope, closing) {
    var $suggestions = $(".search-key-wrapper");
    if (lastResponse !== null && (!$suggestions.is(":visible") || (closing && $suggestions.is(":animated")))) {
        processResponse.call(scope, lastResponse);
    }
}

/**
 * Retrieve suggestions. Only one request is in flight at a time, and a query that hasn't changed isn't sent
 * again: if its suggestions were closed, they are shown again instead.
 *
 * @param {Object} scope - Search field DOM element
 */
function getSuggestions(scope) {
    var query = $(scope).val().trim();

    if (query.length < minChars) {
        resetSuggestState();
        toggleSuggestionsIcon("search");
        clearModals();
        getSuggestionsWrapper(scope).empty();
        return;
    }

    if (query === lastQuery) {
        showLastSuggestions(scope);
        return;
    }

    abortSuggestRequest();
    lastQuery = query;
    lastResponse = null;

    var request = $.ajax({
        context: scope,
        url: endpoint + encodeURIComponent(query),
        method: "GET",
        success: function (response) {
            if (request !== suggestRequest) {
                return;
            }
            suggestRequest = null;
            lastResponse = response;
            processResponse.call(this, response);
        },
        error: function (err) {
            if (err.statusText === "abort") {
                return;
            }
            if (request === suggestRequest) {
                suggestRequest = null;
                lastQuery = null;
            }
            console.error(err);
        }
    });
    suggestRequest = request;
}

/**
 * Handle Search Suggestion Keyboard Arrow Keys
 *
 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
 */
function handleArrow(direction) {
    // get all li elements in the suggestions list
    var suggestionsList = $(".suggestions .item");
    if (suggestionsList.filter(".selected").length === 0) {
        suggestionsList.first().addClass("selected");
        $("input.search-field").each(function () {
            $(this).attr("aria-activedescendant", suggestionsList.first()[0].id);
        });
    } else {
        suggestionsList.each(function (index) {
            var idx = index + direction;
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
                $(this).removeAttr("aria-selected");
                if (suggestionsList.eq(idx).length !== 0) {
                    suggestionsList.eq(idx).addClass("selected");
                    suggestionsList.eq(idx).attr("aria-selected", true);
                    $(this).removeProp("aria-selected");
                    $("input.search-field").each(function () {
                        $(this).attr("aria-activedescendant", suggestionsList.eq(idx)[0].id);
                    });
                } else {
                    suggestionsList.first().addClass("selected");
                    suggestionsList.first().attr("aria-selected", true);
                    $("input.search-field").each(function () {
                        $(this).attr("aria-activedescendant", suggestionsList.first()[0].id);
                    });
                }
                return false;
            }
            return true;
        });
    }
}

module.exports = function () {
    // Delegated rather than bound per tile: a click listener on the tile itself makes Chrome expose
    // it as clickable, which screen readers announce over the tile's own link. Delegating also
    // covers tiles added later, such as search suggestions and Einstein carousel tiles.
    document.addEventListener("click", (event) => {
        const productTile = event.target.closest(".product-tile");

        // Don't fire select_item event when quickview, wishlist or a colour swatch is clicked. Matched with
        // closest() rather than on the target itself: the heart is an SVG inside spans, so the click lands on
        // whichever of them is under the pointer.
        if (productTile && !event.target.closest(".quickview, .wishlistTile, .tile-colour-swatch-list")) {
            gtmHelpers.selectItemEvent(productTile);
        }
    });

    /**
     * Use debounce to avoid making an Ajax call on every single key press by waiting a few
     * hundred milliseconds before making the request. Without debounce, requests in flight
     * together hit the per-session request limit.
     */
    var debounceSuggestions = debounce(getSuggestions, suggestDelay);

    /**
     * Drop the suggest call still waiting on the debounce and abort the request in flight
     */
    var cancelSuggestions = function () {
        debounceSuggestions.cancel();
        abortSuggestRequest();
    };

    $("form[name=\"simpleSearch\"]").submit(function (e) {
        cancelSuggestions();
        var suggestionsList = $(".suggestions .item");
        if (suggestionsList.filter(".selected").length !== 0) {
            e.preventDefault();
            suggestionsList.filter(".selected").find("a")[0].click();
        }
    });

    $("input.search-field").each(function () {
        const searchField = $(this);
        const suggestionsFocusBar = $(".search-focus-wrapper");
        searchField.on("keyup focus", function (e) {
            // Capture Down/Up Arrow Key Events
            switch (e.which) {
                case DOWN_KEY:
                    handleArrow(DIRECTION_DOWN);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case UP_KEY:
                    handleArrow(DIRECTION_UP);
                    e.preventDefault(); // prevent moving the cursor
                    break;
                case ENTER_KEY:
                    // Enter submits the search, which has already cancelled suggestions
                    break;
                default:
                    if (searchField.val().trim().length < minChars) {
                        $(".search-key-wrapper").slideUp();
                        suggestionsFocusBar.slideDown();
                    }

                    debounceSuggestions(this, e);
            }
        });

        searchField.on("focus", function () {
            if (searchField.val().trim() === lastQuery) {
                showLastSuggestions(this, true);
            }
            searchField.attr("placeholder", "");
            searchField.addClass("focused-search");
            searchField.siblings(".reset-button").removeClass("d-none");
            if (searchField.val() === "") {
                const popularCategoriesCarousel = $(".popular-categories-carousel");
                suggestionsFocusBar.slideDown();

                if (!popularCategoriesCarousel.hasClass("slick-initialized")) {
                    popularCategoriesCarousel.slick({
                        slidesToShow: 1.8,
                        slidesToScroll: 1,
                        infinite: false,
                        arrows: false,
                        mobileFirst: true,
                        responsive: [{
                            breakpoint: 768,
                            settings: "unslick"
                        }]
                    });
                }
            }
        });

        searchField.on("blur", function () {
            searchField.removeClass("focused-search");
        });
    });

    $(document).on("click", function (event) {
        const targetElement = event.target;
        const searchInput = $(".search-input");
        const dropdownWrapper = $(".suggest-container");
        const containerElement = $(".search-focus-content");
        const exceptionElement = $(".search-field, .search-button svg");
        const searchPlaceholder = searchInput.attr("aria-placeholder");

        if (!containerElement.is(targetElement) && containerElement.has(targetElement).length === 0 &&
            !exceptionElement.is(targetElement) && exceptionElement.has(targetElement).length === 0) {
            cancelSuggestions();
            $("body").removeClass("no-scroll-mobile");
            dropdownWrapper.slideUp();
            // DGF-4906: a field with typed-out phrases owns its placeholder - resetting it here flashed "Search for
            // products..." over the phrase for up to its 2s hold, on every click anywhere on the page
            searchInput.not("[data-placeholder-phrases]").attr("placeholder", searchPlaceholder);
            if (searchInput.val() === "") {
                $(".reset-button").addClass("d-none");
            }
        }
    });

    $("body").on("click touchend", ".search-mobile button.fa-close", function (e) {
        e.preventDefault();
        $(".suggestions").hide();
        toggleSuggestionsIcon("search");
        debounceSuggestions.cancel();
        tearDownSuggestions();
    });

    $(".site-search .reset-button").on("click", function () {
        const dropdownWrapper = $(".suggest-container");
        const searchInput = $(".search-input");
        const searchPlaceholder = searchInput.attr("aria-placeholder");

        $(this).addClass("d-none");
        debounceSuggestions.cancel();
        resetSuggestState();
        searchInput.attr("placeholder", searchPlaceholder);
        $("body").removeClass("no-scroll-mobile");
        $(".search-key-wrapper").slideUp();
        dropdownWrapper.slideUp();

    });

    $(".site-search .search-button").on("click", function (e) {
        const searchInput = $(".search-input");
        if (searchInput.val() === "") {
            e.preventDefault();
            searchInput.addClass("focused-search").trigger("focus");
        }
    });
};
